import { useTranslation } from 'react-i18next';
import { Square3Stack3DIcon } from '@heroicons/react/24/outline';

import { Button } from 'components/Form/Button';

import { SsccLabelBulkActions } from './SsccLabelBulkActions';

type TransportUnitsHeaderActionsProps = {
  showBuildPackingList: boolean;
  showBulkLabelActions: boolean;
  isSubmitting: boolean;
  visibleTransportUnitsCount: number;
  onBuildPackingList: () => void;
};

export const TransportUnitsHeaderActions = ({
  showBuildPackingList,
  showBulkLabelActions,
  isSubmitting,
  visibleTransportUnitsCount,
  onBuildPackingList,
}: TransportUnitsHeaderActionsProps) => {
  const { t } = useTranslation();

  if (showBuildPackingList) {
    return (
      <Button
        variant="primary"
        size="base"
        LeftIcon={Square3Stack3DIcon}
        disabled={isSubmitting}
        onClick={onBuildPackingList}
        analyticsId="webedi:transport_units_build_packing_list"
      >
        {visibleTransportUnitsCount >= 1
          ? t('webedi:transport_units.edit_packing_list_button.text')
          : t('webedi:transport_units.build_packing_list_button.text')}
      </Button>
    );
  }

  if (showBulkLabelActions) {
    return <SsccLabelBulkActions />;
  }

  return null;
};
